// Image Configuration - Golden Pour
// All images are managed centrally here - no hardcoded image URLs in components

export const imageConfig = {
  // Hero Images
  hero: {
    main: 'https://www.genspark.ai/api/files/s/PIbxkcMc', // Bar counter straight-on view
    alt: 'Golden Pour bar interior showing warm wooden counter with pendant lights and bottle display'
  },

  // Gallery Images for About Page
  gallery: [
    {
      url: 'https://www.genspark.ai/api/files/s/JbpC7lZk',
      alt: 'Golden Pour interior with seating area and natural lighting',
      caption: 'Spacious seating with warm ambiance'
    },
    {
      url: 'https://www.genspark.ai/api/files/s/zsZQCfEs',
      alt: 'Dining area with wooden tables and hanging plants',
      caption: 'Comfortable dining spaces'
    },
    {
      url: 'https://www.genspark.ai/api/files/s/xZkgswE5',
      alt: 'Extended view of seating area with menu boards',
      caption: 'Premium pub atmosphere'
    },
    {
      url: 'https://www.genspark.ai/api/files/s/vgATsnHG',
      alt: 'Lounge area with comfortable sofas and natural light',
      caption: 'Relaxed lounge seating'
    }
  ],

  // Brand Assets
  brand: {
    logo: 'https://www.genspark.ai/api/files/s/hcQCtRJ0',
    logoAlt: 'Golden Pour logo - elegant gold typography on black background'
  },

  // Placeholder Images
  placeholders: {
    beer: '/images/beer-placeholder.jpg',
    brewery: '/images/brewery-placeholder.jpg',
    tapCard: '/images/tap-placeholder.jpg'
  },

  // Icon Images (if needed)
  icons: {
    happyHour: '/images/icons/happy-hour.svg',
    byo: '/images/icons/byo-food.svg',
    local: '/images/icons/local-brewery.svg'
  },

  // Image Processing Settings
  settings: {
    // Lazy loading settings
    lazyLoad: true,
    placeholder: 'blur',
    
    // Responsive image breakpoints
    breakpoints: {
      mobile: 640,
      tablet: 1024,
      desktop: 1280,
      wide: 1536
    },
    
    // Image optimization
    quality: 85,
    format: 'webp'
  }
};